import React, { createRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { toast } from 'react-toastify';

import {
  Visibility,
  History,
  Reply,
  Assessment,
  CancelScheduleSend,
} from '@material-ui/icons';

import { number, formataData, downloadFile } from '~/helpers';

import { UnidataTable } from '~/components';

import {
  operacaoRadPesquisaPreGaturaUnidataInRequest,
  findOperacaoRadPesquisaPreFaturaUnidata,
  recordFiltering,
} from '~/store/modules/operacaoradpesquisaprefaturaunidata/actions';

import DetalhePreFatura from './components/DetalhePreFatura';

import HistoricoPreFatura from './components/HistoricoPreFatura';

import CancelarPreFatura from './components/CancelarPreFatura';

function OperacaoRadPesquisaPreFaturaUnidataLista() {
  const dispatch = useDispatch();

  const buttons = [];

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const operacaoradpesquisaprefaturaunidata = useSelector(
    (state) => state.operacaoradpesquisaprefaturaunidata
  );

  const detalhePreFaturaRef = createRef();

  const historicoPreFaturaRef = createRef();

  const CancelarPreFaturaRef = createRef();

  async function handleUpdate() {
    await dispatch(recordFiltering(operacaoradpesquisaprefaturaunidata.params));
  }

  const openWinBaixarArquivo = React.useCallback((url) => {
    downloadFile(url);
  }, []);

  const openWin = React.useCallback((url) => {
    window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen'
    );
  }, []);

  const reponderContestacao = React.useCallback((value) => {
    if (value.fatu_status === 2) {
      openWin(value.fatu_link_prefatura);
    } else {
      toast.error('O status do registro não permite essa ação.');
    }
  }, []);

  const historicoPeriodo = React.useCallback((value) => {
    openWinBaixarArquivo(value.cosi_url_aplic_rel_rad_getpdf);
  }, []);

  const cancelarPreFatura = React.useCallback(
    (value) => {
      if (value.fatu_status === 2 || value.fatu_status === 4) {
        CancelarPreFaturaRef.current.handleToggleModal(value);
      } else {
        toast.error('O status do registro não permite essa ação.');
      }
    },
    [CancelarPreFaturaRef]
  );

  const status = useMemo(
    () => [
      { value: 'Aguardando Aprovação Gestor do Órgão', label: '1' },
      { value: 'Aguardando Emissão', label: '0' },
      { value: 'Aguardando Emissão da Fatura', label: '5' },
      { value: 'Aguardando Emissão Pedido de Faturamento', label: '4' },
      { value: 'Aprovado Gestor do Órgão', label: '201' },
      { value: 'Aprovado Gestor do Estado', label: '202' },
      { value: 'Cancelada por Contestação', label: '8' },
      { value: 'Contestação do Gestor do Órgão', label: '2' },
      { value: 'Contestação respondida pela Abastek', label: '3' },
      { value: 'Contestação do Gestor do Estado', label: '302' },
      { value: 'Contestação do Gestor do Estado respondida pela Abastek', label: '303' },
      { value: 'Fatura enviada para Órgão', label: '6' },
      { value: 'Fatura Paga', label: '7' },
      { value: 'Gestor do Estado Selecionou para Geração do Faturamento', label: '203' },
      { value: 'Vencida', label: '100' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'orga_sigla',
        label: 'Órgão',
        align: 'left',
      },

      {
        id: 'fatu_codigo',
        label: 'Pré-fatura',
        align: 'right',
      },
      {
        id: 'fatu_periodo',
        label: 'Período',
        align: 'center',
      },
      {
        id: 'fatu_datahora_geracao',
        label: 'Data Geração',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_status_str',
        label: 'Status',
        align: 'center',
        converter: status,
        filter: {
          type: 'select',
          options: status,
        },
      },
      {
        id: 'fatu_valor_servico',
        label: 'Valor do Serviço (R$)',
        formatted: (value) => number(value, 'currency'),
        align: 'right',
      },
      {
        id: 'fatu_valor_nota_fiscal',
        label: 'Valor Nota Fiscal (R$)',
        formatted: (value) => number(value, 'currency'),
        align: 'right',
      },
      {
        id: 'fatu_total_retencao',
        label: 'Total das retenções (R$)',
        formatted: (value) => number(value, 'currency'),
        align: 'right',
      },
      {
        id: 'usua_nome_gestor_validacao',
        label: 'Aprovado por',
        align: 'left',
      },
      {
        id: 'fatu_datahora_validacao_gestor',
        label: 'Aprovado em',
        align: 'center',
        formatted: (value) => formataData(value),
      },

      {
        id: 'usua_login_cancelamento',
        label: 'Cancelado por',
        align: 'left',
      },
      {
        id: 'fatu_data_cancelamento',
        label: 'Cancelado em',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_numero_pedido',
        label: 'Pedido',
        align: 'right',
      },
      {
        id: 'fatu_data_envio_fatura',
        label: 'Data do Pedido',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_nota_fiscal',
        label: 'Nota Fiscal',
        align: 'right',
      },
      {
        id: 'fatu_data_fatura',
        label: 'Data Envio NF',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_data_vencimento',
        label: 'Data Vencimento NF',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_data_pagamento',
        label: 'Pago em',
        align: 'center',
        formatted: (value) => formataData(value),
      },
      {
        id: 'fatu_dias_vencimento',
        label: 'Dias Para Vencimento',
        align: 'center',
        styled: (value) =>
          value < 0 ? { color: '#ff0000' } : { color: '#00B300' },
      },
      {
        id: 'fatu_dias_pagto_apos_vencimento',
        label: 'Pagos após vencimento',
        align: 'center',
      },
    ],
    []
  );

  const headerbuttons = useMemo(
    () => [
      buttons.push({
        title: 'Relatório analítico de despesas',
        action: (value) => detalhePreFaturaRef.current.handleToggleModal(value),
        icon: <Visibility />,
      }),

      buttons.push({
        title: 'Histórico da Pré-fatura',
        action: (value) =>
          historicoPreFaturaRef.current.handleToggleModal(value),
        icon: <History />,
      }),

      itemSelecionado.fatu_status === 2 &&
      buttons.push({
        title: 'Responder Contestação',
        action: (value) => reponderContestacao(value),
        icon: <Reply />,
      }),

      buttons.push({
        title: 'Dados do Período',
        action: (value) => historicoPeriodo(value),
        icon: <Assessment />,
      }),

      (itemSelecionado.fatu_status === 2 ||
        itemSelecionado.fatu_status === 4) &&
      buttons.push({
        title: 'Cancelar Pre-fatura',
        action: (value) => cancelarPreFatura(value),
        icon: <CancelScheduleSend />,
      }),
    ],
    [operacaoradpesquisaprefaturaunidata, itemSelecionado]
  );

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaoradpesquisaprefaturaunidata]
  );

  const filter = useMemo(
    () => [
      {
        id: 'orga_codigo',
        label: 'Órgão',
        type: 'autocomplete',
        autocomplete: {
          url: 'orgaos',
          label: 'orga_nome',
          unique: 'orga_codigo',
          params: {
            fieldlist: 'orga_codigo, orga_nome',
          },
        },
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="fatu_codigo ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        find={findOperacaoRadPesquisaPreFaturaUnidata}
        redux={operacaoradpesquisaprefaturaunidata}
        read={operacaoRadPesquisaPreGaturaUnidataInRequest}
        actions={buttons}
        detach="fatu_codigo"
        custom={filter}
        onRow={(values) => registroSelecionado(values)}
        view="vw_faturamento_rad_sgta"
        reportTitle="Pesquisa Pré-Fatura Abastek"
      />

      <DetalhePreFatura
        ref={detalhePreFaturaRef}
        update={() => handleUpdate()}
        name="teste"
      />

      <HistoricoPreFatura
        ref={historicoPreFaturaRef}
        update={() => handleUpdate()}
        name="teste"
      />

      <CancelarPreFatura
        ref={CancelarPreFaturaRef}
        update={() => handleUpdate()}
        name="teste"
      />
    </>
  );
}

export default OperacaoRadPesquisaPreFaturaUnidataLista;
